<div class="modal-body did-order">
  <div class="content">
    <div class="content__top">
      <i *ngIf="step === 'recap'" class="icon-small-back" (click)="onGoBack()"></i>
      <h4 translate>company.dids.dids-list.popup.create.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>

    <ng-container *ngIf="step === 'did-data'">
      <form *ngIf="!loading.get" class="content__form" [formGroup]="form">
        <div class="form-group">
          <label for="did-order-country" translate>company.dids.dids-list.popup.create.form.country.label</label>
          <vox-select-country [language]="currentLanguage" [searchEnabled]="false" [dense]="true"
            [countryList]="availableCountries" formControlName="country">
          </vox-select-country>
        </div>
        <div class="form-group">
          <label for="did-order-class" translate>company.dids.dids-list.popup.create.form.class.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="did-order-class" ngbDropdownToggle>
              <span>{{form.value.class | didClass}}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="did-order-class">
              <button ngbDropdownItem class="dropdown__item" *ngFor="let class of availableClasses"
                (click)="selectClass(class)">
                <span>{{class | didClass}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="did-order-type" translate>company.dids.dids-list.popup.create.form.type.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="did-order-type" ngbDropdownToggle>
              <span>{{form.value.type | didType}}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="did-order-type">
              <button ngbDropdownItem class="dropdown__item" *ngFor="let type of availableTypes"
                (click)="selectType(type)">
                <span>{{type | didType}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="did-order-area-code" translate>company.dids.dids-list.popup.create.form.area-code.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                      'vox-input-group_invalid': isFieldValid('prefix')}">
            <vox-select-prefix [language]="currentLanguage" [dense]="true" [country]="form.value.country.iso2"
              formControlName="prefix">
            </vox-select-prefix>
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.dids.verification-data.popup.form.error.required</span>
          </div>
        </div>
        <div class="form-group">
          <label for="did-order-coupon-id" translate>company.dids.dids-list.popup.create.form.coupon-id.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('couponId')}">
            <input class="vox-text-field" type="text" id="did-order-coupon-id" formControlName="couponId"
              [placeholder]="'company.dids.dids-list.popup.create.form.coupon-id.placeholder' | translate"><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
              class="vox-input-group__error-message"
              translate>company.dids.verification-data.popup.form.error.required</span>
          </div>
        </div>
        <div class="form-group">
          <gdp-verification-data-selection-form [language]="currentLanguage" [country]="country" [dids]="dids"
            [requirements]="requirements" [allowNoVD]="allowNoVD"
            *ngIf="!loading.vdData && requirements.BUSINESS && requirements.PRIVATE"
            (onEmitVerificationData)="onFormChange($event)">
          </gdp-verification-data-selection-form>
          <div *ngIf="loading.vdData">
            <ngx-skeleton-loader [theme]="{'height':'56px'}"></ngx-skeleton-loader>
          </div>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit" [disabled]="isDisabled()"
            [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff"
            (click)="planAddonHandling === 'manual' ? onSubmit() : onGoNext()">
            <span *ngIf="planAddonHandling !== 'manual'" translate>company.dids.dids-list.popup.create.form.buttons.next</span>
            <span *ngIf="planAddonHandling === 'manual'" translate>company.dids.dids-list.popup.create.form.buttons.create</span>
          </button>
        </div>
      </form>
      <div *ngIf="loading.get">
        <ngx-skeleton-loader [theme]="{'height':'600px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'recap'">
      <gdp-payment-info
      [product]="product"
      [country]="country"
      [chargebeeAccount]="subscription.chargebee_account"
      [companyId]="companyId"
      [canModifyCoupon]="false">
      </gdp-payment-info>
      <gdp-subscription-change-checkboxes
        (onEmitFormValue)="checkboxesData = $event">
      </gdp-subscription-change-checkboxes>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" type="submit" [disabled]="!checkboxesData.isValid"
          [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff" (click)="onSubmit()">
          <span translate>company.dids.dids-list.popup.create.form.buttons.create</span>
        </button>
      </div>
    </ng-container>
  </div>
</div>
